import styled from "@emotion/styled";

export const LoginCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 70px;
    > div {
        width: 100%;
        padding: 30px 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 30px;
    }
    max-width: 396px;
    margin: 0 15px;
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 0 auto;
        max-width: 520px;
        > div {
            padding: 45px;
        }
    }
    ${({ theme }) => theme.mediaQueries.lg} {
        max-width: 918px;
        > div {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
`;

export const LogoContainer = styled.div`
    svg {
        margin-bottom: 15px;
        height: 20px;
        width: 105px;
        ${({ theme }) => theme.mediaQueries.sm} {
            height: 30px;
            width: 157px;
        }
    }
`;

export const LoginPageLeftColumn = styled.div`
    ${({ theme }) => theme.mediaQueries.lg} {
        width: 315px;
    }
`;

export const LoginCardColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    button {
        align-self: flex-end;
    }
    div:has(input) {
        margin: 0px;
    }
    ${({ theme }) => theme.mediaQueries.lg} {
        width: 483px;
    }
`;

export const FormContainer = styled.div`
    align-self: stretch;
    max-width: 461px;
`;

export const CheckboxesContainer = styled.div`
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    align-self: stretch;
    flex-wrap: wrap;
    width: 100%;
    padding-top: 20px;
    gap: 15px;
    > label {
        flex-basis: 590px;
    }
    ${({ theme }) => theme.mediaQueries.lg} {
        gap: 30px;
        > label {
            flex-basis: 430px;
        }
    }
    ${({ theme }) => theme.mediaQueries["2xl"]} {
        > label {
            flex-basis: 390px;
            margin-bottom: 0px;
        }
    }
`;

export const SwitchContainer = styled.div`
    width: fit-content;
`;

export const ButtonRow = styled.div`
    padding-top: 15px;
    display: flex;
    flex-direction: column;
`;
